import { Pipe, PipeTransform } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';
import { CalendarEventTitleFormatter } from './calendar-event-title-formatter.provider';

@Pipe({
  name: 'calendarEventTitle'
})
export class CalendarEventTitlePipe implements PipeTransform {
  constructor(private calendarEventTitle: CalendarEventTitleFormatter) {}

  transform(title: string, titleType: string, event: CalendarEvent): string {
    //console.log(this.calendarEventTitle[titleType](event));
    return this.calendarEventTitle[titleType](event);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/calendar/common/calendar-event-title.pipe.ts